import { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { TENANTS } from "@/constants/testIds";

const empty = { name: "", email: "", phone: "", document_id: "", notes: "", active: true };

export default function TenantDialog({ open, onOpenChange, tenant, onSaved }) {
  const [form, setForm] = useState(empty);
  useEffect(() => { setForm(tenant ? { ...empty, ...tenant } : empty); }, [tenant, open]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (tenant?.id) {
        await api.put(`/tenants/${tenant.id}`, form);
        toast.success("Inquilino actualizado");
      } else {
        await api.post("/tenants", form);
        toast.success("Inquilino creado");
      }
      onSaved?.();
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={TENANTS.dialog} className="max-h-[88vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading">{tenant ? "Editar inquilino" : "Nuevo inquilino"}</DialogTitle>
          <DialogDescription>Datos de contacto y estado del inquilino.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2">
            <Label>Nombre completo</Label>
            <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="tenant-form-name" />
          </div>
          <div>
            <Label>Email</Label>
            <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <Label>Teléfono</Label>
            <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          </div>
          <div>
            <Label>Documento (DNI/RFC/SSN)</Label>
            <Input value={form.document_id} onChange={(e) => setForm({ ...form, document_id: e.target.value })} />
          </div>
          <div className="flex items-end gap-3">
            <div>
              <Label>Activo</Label>
              <div className="pt-2"><Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} /></div>
            </div>
          </div>
          <div className="sm:col-span-2">
            <Label>Notas</Label>
            <Textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
          </div>
          <DialogFooter className="sm:col-span-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" data-testid="tenant-form-submit">Guardar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
